import React, { useState, useEffect } from 'react';
import { get, post } from '@/features/shared/lib/api';

export default function Notification() {
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [notifications, setNotifications] = useState({
    noti_myresource: false,
    noti_myresource_date: '',
    noti_coauthor: false,
    noti_coauthor_date: '',
    noti_favorite: false,
    noti_favorite_date: '',
  });

  const settings = [
    { key: 'noti_myresource', dateKey: 'noti_myresource_date', label: '내 논문 등재 알림 메일 받기' },
    { key: 'noti_coauthor', dateKey: 'noti_coauthor_date', label: '과거 공동 연구자에게 내 논문 등재 메일 알림 발송' },
    { key: 'noti_favorite', dateKey: 'noti_favorite_date', label: '등록한 선호 연구자 알림 메일 받기' },
  ];

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    const scholarId = typeof rmVars !== 'undefined' && rmVars?.scholar_id ? rmVars.scholar_id : null;
    if (!scholarId) {
      setFetching(false);
      return;
    }

    try {
      setFetching(true);
      const response = await get(`/rm/v1/scholar/${scholarId}/notification`);
      if (response?.status && response?.result) {
        const data = response.result;
        setNotifications({
          noti_myresource: data.noti_myresource === 'Y' || data.noti_myresource === true,
          noti_myresource_date: data.noti_myresource_date || '',
          noti_coauthor: data.noti_coauthor === 'Y' || data.noti_coauthor === true,
          noti_coauthor_date: data.noti_coauthor_date || '',
          noti_favorite: data.noti_favorite === 'Y' || data.noti_favorite === true,
          noti_favorite_date: data.noti_favorite_date || '',
        });
      }
    } catch (error) {
      console.error('Fetch notification settings error:', error);
    } finally {
      setFetching(false);
    }
  };

  const handleToggle = (key) => {
    setNotifications((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleUpdate = async () => {
    const scholarId = typeof rmVars !== 'undefined' && rmVars?.scholar_id ? rmVars.scholar_id : null;
    if (!scholarId) {
      alert('사용자 정보를 찾을 수 없습니다.');
      return;
    }

    try {
      setLoading(true);
      // 백엔드에는 boolean 값들만 보냄 (또는 필요에 따라 조절)
      const payload = {
        noti_myresource: notifications.noti_myresource,
        noti_coauthor: notifications.noti_coauthor,
        noti_favorite: notifications.noti_favorite,
      };
      const response = await post(`/rm/v1/scholar/${scholarId}/update_notification`, payload);

      if (response?.status) {
        alert('알림 설정이 저장되었습니다.');
      } else {
        alert(response?.message || '저장에 실패했습니다.');
      }
    } catch (error) {
      console.error('Update notification error:', error);
      alert('처리 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  if (fetching) {
    return <div className="p-8 text-center text-[#8D9AAF]">Loading settings...</div>;
  }

  return (
    <div>
      <div className="flex justify-between items-center w-full">
        <h3 className="mypage-subpage-title text-[26px] lg:text-[24px] font-black lg:font-bold leading-[130%] lg:leading-[100%]">Notification</h3>

        <div className="hidden lg:flex gap-2 items-center">
          <button
            onClick={handleUpdate}
            disabled={loading}
            className="btn-edit flex rounded-[12px] items-center justify-center gap-2 px-4 py-3 text-[14px] text-white font-semibold leading-[100%] bg-[#333] disabled:opacity-50"
          >
            <img src={rmVars.themeUrl + 'images/check-ico.png'} className="w-[18px]" alt="edit" />
            <span>{loading ? 'Updating...' : 'Update'}</span>
          </button>
        </div>
      </div>

      <div className="mypage-card mt-[40px] lg:mt-6 lg:p-[60px] bg-white rounded-[12px]">
        <div className="mb-10 lg:mb-[50px]">
          <p className="mb-4 text-[18px] font-bold">Email Notification Settings</p>
          <div>
            <table className="w-full border-t border-t-[#E4E8F1]">
              <thead className="hidden lg:table-header-group">
                <tr>
                  <th className="py-4 text-left text-[14px] font-bold text-[#333]">알림 내용</th>
                  <th className="py-4 text-center text-[14px] font-bold text-[#333] w-[100px]">알림 여부</th>
                </tr>
              </thead>
              <tbody>
                {settings.map(({ key, dateKey, label }) => (
                  <tr key={key} className="border-b border-[#E4E8F1]">
                    <td className="py-5 text-left text-[14px] text-[#555] leading-[120%] !whitespace-normal">
                      {label}
                    </td>
                    <td className="py-5 text-center">
                      <label className="relative inline-flex items-center cursor-pointer align-text-bottom">
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={notifications[key]}
                          onChange={() => handleToggle(key)}
                        />
                        <div className="w-[25px] h-[15px] bg-[#B4BCCC] rounded-full peer peer-checked:bg-[#4B4DFF] transition-colors duration-200"></div>
                        <div className="absolute right-[2px] top-[2px] w-[11px] h-[11px] bg-white rounded-full transition-transform duration-200 peer-checked:translate-x-[-10px]"></div>
                      </label>
                      {notifications[key] && notifications[dateKey] && (
                          <>
                            <br />
                            <span className="text-[12px] text-[#8D9AAF]">{notifications[dateKey]}</span>
                          </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="lg:hidden mt-8">
          <button
            onClick={handleUpdate}
            disabled={loading}
            className="w-full flex rounded-[12px] items-center justify-center gap-2 px-4 py-4 text-[16px] text-white font-bold bg-[#333] disabled:opacity-50"
          >
            <span>{loading ? 'Updating...' : 'Save Settings'}</span>
          </button>
        </div>
      </div>
    </div>
  );
}
